import { render, staticRenderFns } from "./CommunityGasOverView.vue?vue&type=template&id=4013312c&scoped=true"
import script from "./CommunityGasOverView.vue?vue&type=script&lang=js"
export * from "./CommunityGasOverView.vue?vue&type=script&lang=js"
import style0 from "./CommunityGasOverView.vue?vue&type=style&index=0&id=4013312c&prod&lang=sass&scoped=true"
import style1 from "./CommunityGasOverView.vue?vue&type=style&index=1&id=4013312c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013312c",
  null
  
)

export default component.exports